import { sha1 } from 'object-hash';
export function getObjectHash(obj) {
    return sha1(obj);
}
